export function transformTargetadsUrl(url: string, name: string): string {
  const isPixel = [
    'click_audit_pixel',
    'pixel',
    'pixel_additional',
    'pixel_additional2',
  ].includes(name);
  const isLink = name === 'link';

  // Если не Targetads или не link/pixel поле - возвращаем как есть
  if (!url.includes('eye.targetads.io') || (!isLink && !isPixel)) {
    return url;
  }

  let result = url;

  // Для link поля
  if (isLink) {
    // Проверяем, что это /view/click
    if (!result.includes('/view/click')) {
      return result;
    }

    // Добавляем параметры если их нет
    if (!result.includes('s_trk=')) {
      result += `${result.includes('?') ? '&' : '?'}s_trk={TR_KEY}`;
    }
    if (!result.includes('erid=')) {
      result += '&erid={ERID}';
    }
  }

  // Для pixel поля
  // Ничего не делаем - просто возвращаем как есть
  // (проверка на /view/pixel не обязательна, так как по требованию - без изменений)

  return result;
}

export function transformTargetadsJs(jscode: string, name: string): string {
  if (name !== 'js_code_audit') {
    return jscode;
  }

  // Проверяем наличие eye.targetads.io
  if (!jscode.includes('eye.targetads.io')) {
    return jscode;
  }

  // Просто извлекаем нужные части с помощью регулярных выражений
  const typeRegex = /type\s*=\s*["']text\/javascript["']/i;
  const dataPixelRegex = /data-pixel\s*=\s*["']([^"']*)["']/i;
  const dataTrackingRegex = /data-tracking\s*=\s*[']([^']*)[']/i;
  const srcRegex = /src\s*=\s*["']([^"']*)["']/i;

  const hasType = typeRegex.test(jscode);
  const dataPixelMatch = jscode.match(dataPixelRegex);
  const dataTrackingMatch = jscode.match(dataTrackingRegex);
  const srcMatch = jscode.match(srcRegex);

  // Обязательные атрибуты
  if (!dataPixelMatch || !srcMatch) {
    return jscode;
  }

  // Обрабатываем data-pixel
  let dataPixelValue = dataPixelMatch[1];
  dataPixelValue = dataPixelValue.replace(/&amp;/g, '&');

  // Собираем атрибуты
  const attributes = [];

  if (hasType) {
    attributes.push('type="text/javascript"');
  }

  attributes.push(`data-pixel="${dataPixelValue}"`);

  if (dataTrackingMatch) {
    attributes.push(`data-tracking='${dataTrackingMatch[1]}'`);
  }

  attributes.push(`src="${srcMatch[1]}"`);

  // Собираем новый тег
  return `<script ${attributes.join(' ')}></script>`;
}

export function transformTargetadsVastUrl(url: string, name: string): string {
  if (name !== 'data.vast_url') {
    return url;
  }

  if (!url.includes('eye.targetads.io')) {
    return url;
  }

  try {
    const [base, query = ''] = url.split('?');

    // Преобразуем строку запроса в объект
    const params = query
      ? query.split('&').reduce<Record<string, string>>((acc, param) => {
          const [key, value = ''] = param.split('=');
          // eslint-disable-next-line no-param-reassign
          acc[key] = value;
          return acc;
        }, {})
      : {};

    // Обновляем параметры
    if (!params.s_trk || !params.s_trk.includes('{TR_KEY}')) {
      params.s_trk = '{TR_KEY}';
    }

    if (!params.erid || !params.erid.includes('{ERID}')) {
      params.erid = '{ERID}';
    }

    // Собираем обратно
    const queryString = Object.entries(params)
      .map(([key, value]) => `${key}=${value}`)
      .join('&');

    return queryString ? `${base}?${queryString}` : base;
  } catch (error) {
    console.error('Error transforming Targetads VAST URL:', error);
    return url;
  }
}
